<template>
  <div class="tw-relative tw-min-h-[calc(100vh-146px)] tw-bg-bgPage">
    <BaseTopLine></BaseTopLine>
    <div>
      <div
        class="tw-bg-main2 tw-py-[10px] tw-px-[20px] tw-rounded-[6px] tw-mx-[26px] tw-text-[12px]"
        :key="counter"
      >
        <div class="tw-flex tw-items-end flex-wrap tw-gap-[10px] tw-text-white">
          <div class="tw-app-input-container tw-max-w-[100px]">
            <label class="tw-app-input-container-label">
              {{ dataLang["orders-page__table__header_order_text2"] }}
            </label>
            <BaseInputNew
              @keyupEnter="loadData(1)"
              inputClass="tw-app-input-dark"
              @input="fillFilter"
              inputName="orders__id"
            />
          </div>

          <div class="tw-app-input-container tw-max-w-[300px]">
            <label class="tw-app-input-container-label">
              {{ dataLang["orders_page_text11"] }}
            </label>
            <div class="tw-flex tw-gap-[10px] tw-items-center">
              <BaseDatePicker
                class="tw-bg-white !tw-text-white tw-bg-opacity-[15%] tw-rounded-[3px] [&_i]:!tw-text-white"
                input-class="tw-app-input-dark !tw-bg-transparent tw-w-full"
                v-model="dataTimeSelect.orders_from"
                type="date"
                lang="ru"
                id="vehicle_osago__policy_from"
                value-type="format"
                :format="userSetting.company__tempalte_date"
                @change="
                  (date) =>
                    fillDateFilter({
                      value: date,
                      name: 'orders__created_at',
                      index: 0,
                    })
                "
                :disabled-date="disabledFutureDates"
              >
              </BaseDatePicker>
              -
              <BaseDatePicker
                class="tw-bg-white !tw-text-white tw-bg-opacity-[15%] tw-rounded-[3px] [&_i]:!tw-text-white"
                input-class="tw-app-input-dark !tw-bg-transparent tw-w-full"
                v-model="dataTimeSelect.orders_to"
                type="date"
                lang="ru"
                id="vehicle_osago__policy_from"
                value-type="format"
                :format="userSetting.company__tempalte_date"
                @change="
                  (date) =>
                    fillDateFilter({
                      value: date,
                      name: 'orders__created_at',
                      index: 1,
                    })
                "
                :disabled-date="
                  (date) =>
                    disabledPastDates(
                      dataTimeSelect.orders_from
                        ?.split('.')
                        ?.reverse()
                        ?.join('-'),
                      date
                    )
                "
              >
              </BaseDatePicker>
            </div>
          </div>

          <div
            class="tw-app-input-container multiselect-type-1 tw-max-w-[200px]"
          >
            <label class="tw-app-input-container-label">
              {{ dataLang["orders-page__table__header_order_text4"] }}
            </label>
            <BaseSelect
              v-model="selectsFilter.ads"
              label="ads__name"
              @input="setSelect($event, `ads__name`, `ads__name`)"
              placeholder=""
              selectLabel=""
              deselectLabel=""
              :options="selectsData.ads"
            >
              <template slot="noOptions">{{
                dataLang["select_empty"]
              }}</template>
              <template slot="noResult">{{
                dataLang["select_search_empty"]
              }}</template>
              <template slot="selectedLabel">{{
                dataLang["select_selected"]
              }}</template>
              <template slot="deselectLabel">{{
                dataLang["select_unselect"]
              }}</template>
            </BaseSelect>
          </div>

          <div
            class="tw-app-input-container multiselect-type-1 tw-max-w-[200px]"
          >
            <label class="tw-app-input-container-label">
              {{ dataLang["orders-page__table__header_order_text5"] }}
            </label>
            <BaseSelect
              v-model="selectsFilter.type"
              label="label"
              @input="setSelect($event, `orders__type_rent`, `value`)"
              placeholder=""
              selectLabel=""
              deselectLabel=""
              :options="selectsData.types.orders__type_rent"
            >
              <template slot="noOptions">{{
                dataLang["select_empty"]
              }}</template>
              <template slot="noResult">{{
                dataLang["select_search_empty"]
              }}</template>
              <template slot="selectedLabel">{{
                dataLang["select_selected"]
              }}</template>
              <template slot="deselectLabel">{{
                dataLang["select_unselect"]
              }}</template>
            </BaseSelect>
          </div>

          <div
            class="tw-app-input-container multiselect-type-1 tw-max-w-[200px]"
          >
            <label class="tw-app-input-container-label">
              {{ dataLang["orders-page__table__header_order_text6"] }}
            </label>
            <BaseSelect
              v-model="selectsFilter.type"
              :customLabel="
                ({ vehicle_types__code }) => {
                  return dataLang[vehicle_types__code];
                }
              "
              @input="
                setSelect($event, `orders__vehicle_type`, `vehicle_types__code`)
              "
              placeholder=""
              selectLabel=""
              deselectLabel=""
              :options="objectsTypesFiltered"
            >
              <template slot="noOptions">{{
                dataLang["select_empty"]
              }}</template>
              <template slot="noResult">{{
                dataLang["select_search_empty"]
              }}</template>
              <template slot="selectedLabel">{{
                dataLang["select_selected"]
              }}</template>
              <template slot="deselectLabel">{{
                dataLang["select_unselect"]
              }}</template>
            </BaseSelect>
          </div>

          <div
            class="tw-app-input-container multiselect-type-1 tw-max-w-[200px]"
          >
            <label class="tw-app-input-container-label">
              {{ dataLang["orders-page__table__header_order_text7"] }}
            </label>
            <BaseSelect
              v-model="selectsFilter.bodyGenerations"
              :customLabel="
                ({ vehicles_body_generation__body_generation }) => {
                  return dataLang[vehicles_body_generation__body_generation];
                }
              "
              @input="
                setSelect(
                  $event,
                  `orders__body_generation`,
                  `vehicles_body_generation__body_generation`
                )
              "
              placeholder=""
              selectLabel=""
              deselectLabel=""
              :options="selectsData.bodyGenerations"
            >
              <template slot="noOptions">{{
                dataLang["select_empty"]
              }}</template>
              <template slot="noResult">{{
                dataLang["select_search_empty"]
              }}</template>
              <template slot="selectedLabel">{{
                dataLang["select_selected"]
              }}</template>
              <template slot="deselectLabel">{{
                dataLang["select_unselect"]
              }}</template>
            </BaseSelect>
          </div>

          <div class="tw-app-input-container tw-max-w-[200px]">
            <label class="tw-app-input-container-label">
              {{ dataLang["orders-page__table__header_order_text12"] }}
            </label>
            <BaseInputNew
              @keyupEnter="loadData(1)"
              inputClass="tw-app-input-dark"
              @input="fillFilter"
              inputName="vehicles__fullname"
            />
          </div>

          <div class="tw-app-input-container tw-max-w-[200px]">
            <label class="tw-app-input-container-label">
              {{ dataLang["orders-page__table__header_client_text3"] }}
            </label>
            <BaseInputNew
              @keyupEnter="loadData(1)"
              inputClass="tw-app-input-dark"
              @input="fillFilter"
              inputName="clients__fullname"
              :additionalParams="{ type: 'like' }"
            />
          </div>

          <div
            class="tw-app-input-container multiselect-type-1 tw-max-w-[200px]"
          >
            <label class="tw-app-input-container-label">
              {{ dataLang["orders-page__table__header__order_text8"] }}
            </label>
            <BaseSelect
              v-model="selectsFilter.citiesStart"
              label="cities__name"
              @input="setSelect($event, `orders__start_city_id`, `cities__id`)"
              placeholder=""
              selectLabel=""
              deselectLabel=""
              :options="selectsData.cities"
            >
              <template slot="noOptions">{{
                dataLang["select_empty"]
              }}</template>
              <template slot="noResult">{{
                dataLang["select_search_empty"]
              }}</template>
              <template slot="selectedLabel">{{
                dataLang["select_selected"]
              }}</template>
              <template slot="deselectLabel">{{
                dataLang["select_unselect"]
              }}</template>
            </BaseSelect>
          </div>

          <div
            class="tw-app-input-container multiselect-type-1 tw-max-w-[200px]"
          >
            <label class="tw-app-input-container-label">
              {{ dataLang["orders-page__table__header_order_text9"] }}
            </label>
            <BaseSelect
              v-model="selectsFilter.citiesEnd"
              label="cities__name"
              @input="setSelect($event, `orders__end_city_id`, `cities__id`)"
              placeholder=""
              selectLabel=""
              deselectLabel=""
              :options="selectsData.cities"
            >
              <template slot="noOptions">{{
                dataLang["select_empty"]
              }}</template>
              <template slot="noResult">{{
                dataLang["select_search_empty"]
              }}</template>
              <template slot="selectedLabel">{{
                dataLang["select_selected"]
              }}</template>
              <template slot="deselectLabel">{{
                dataLang["select_unselect"]
              }}</template>
            </BaseSelect>
          </div>

          <div class="tw-flex tw-flex-row">
            <button
              @click="loadData(1)"
              type="button"
              class="tw-app-btn-primary"
            >
              Найти
              <!-- {{ dataLang["register_btn_filter_on"] }} -->
            </button>
            <button @click="resetFilter" type="button" class="tw-app-btn-light">
              Сбросить
              <!-- {{ dataLang["register_btn_filter_off"] }} -->
            </button>
          </div>
        </div>
      </div>

      <div class="tw-px-[26px]">
        <div class="tw-my-[15px] tw-flex tw-gap-[15px]">
          <button class="tw-app-btn-primary-outline" @click="acceptDelete">
            <img
              :src="require(`@/assets/icons/minus-dark.svg`)"
              width="13.5"
              height="13.5"
              class="tw-my-[-5px]"
            />
            {{ dataLang["orders_page_btn_text6"] }}
          </button>
          <button class="tw-app-btn-primary-outline" @click="fromArchive">
            <img
              :src="require(`@/assets/icons/document-previous.svg`)"
              width="16"
              height="16"
              class="tw-my-[-5px]"
            />
            {{ dataLang["orders_page_btn_text8"] }}
          </button>
        </div>

        <div
          v-if="countOrders"
          class="tw-my-[15px] tw-text-[12px] tw-text-forText tw-flex tw-gap-[30px]"
        >
          <div>{{ dataLang["orders_page_text7"] }}: {{ countOrders }}</div>
          <div>
            {{ dataLang["orders_page_text8"] }}:
            {{ statistics?.new?.count }} ({{
              statistics?.new?.percent?.toFixed(1)
            }}%)
          </div>
          <div>
            {{ dataLang["orders_page_text9"] }}:
            {{ statistics?.permanent?.count }}
            ({{ statistics?.permanent?.percent?.toFixed(1) }}%)
          </div>
          <div>
            {{ dataLang["orders_page_text10"] }}:
            {{ statistics?.super?.count }} ({{
              statistics?.super?.percent?.toFixed(1)
            }}%)
          </div>
        </div>

        <div class="tw-my-[15px] tw-flex tw-justify-end">
          <TwBasePagination
            :page-count="computedAllPage"
            :pagination-params="{
              ...activePagePagination,
              limit: limitPaginationValue,
            }"
            @updateLimitValue="updateLimitValue"
            :page-range="10"
            :margin-pages="2"
            :click-handler="loadData"
          >
          </TwBasePagination>
        </div>

        <div class="tw-relative">
          <BaseLoader v-if="localLoading"></BaseLoader>
          <ve-table
            class="fixed-header rest-style-table"
            style="width: 100%"
            :columns="columns"
            :table-data="dataTable"
            :border-x="true"
            :border-y="true"
            row-key-field-name="orders__id"
            ref="mainTable"
            :checkbox-option="{
              hideSelectAll: true,
              selectedRowChange: selectedRowChange,
            }"
            v-if="!localLoading"
            :clickHighlight="false"
            :cell-style-option="cellStyleOption"
            :rowStyleOption="{
              hoverHighlight: true,
            }"
            :cellSelectionOption="{ enable: false }"
          />
        </div>
      </div>
    </div>

    <BaseModal
      name="acceptDeleteWithPin"
      width="420"
      :clickToClose="false"
      :shiftY="0.5"
      @before-close="pincodeModalHandler"
      :adaptive="true"
      height="auto"
      classes="tw-app-modal"
    >
      <div class="tw-app-modal__container">
        <BaseLoader v-if="localLoading" class="tw-rounded-[25px]"></BaseLoader>
        <button
          type="button"
          class="btn-close tw-app-modal__close"
          @click="$modal.hide('acceptDeleteWithPin')"
        ></button>

        <div class="tw-text-center">
          <div class="tw-app-modal__title">Внимание!</div>
          <div class="tw-my-[15px]">Введите пароль администратора!</div>
          <BaseInputNew
            inputClass="tw-app-input-type-3"
            :input-name="'pincode'"
            @input="(data) => (pincode = data.value)"
          >
          </BaseInputNew>
          <div class="tw-app-modal__footer">
            <button
              @click="$modal.hide('acceptDeleteWithPin')"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["vehile_modal_btn_reset"] }}
            </button>
            <button
              @click="acceptDelete"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              {{ dataLang["vehile_modal_btn_save"] }}
            </button>
          </div>
        </div>
      </div>
    </BaseModal>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import { VeTable } from "vue-easytable";
import ObjectsService from "@/api/ObjectsService";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import SelectsService from "@/api/SelectsService";
import GeneralService from "@/api/GeneralService";
import { globalMixin } from "@/mixins/global";

export default {
  mixins: [globalMixin],
  components: {
    VeTable,
  },

  props: {
    modeOpenModal: {
      type: String,
      default: "create",
    },

    currentOpenedId: {
      type: Number,
    },
  },

  data() {
    return {
      counter: 0,
      dataTimeSelect: { orders_from: "", orders_to: "" },
      selectsData: {
        types: [],
        statuses: [],
        ads: [],
        objectTypes: [],
        bodyGenerations: [],
        cities: [],
      },
      selectsFilter: {
        type: [],
        statuses: [],
        ads: null,
        objectTypes: null,
        bodyGenerations: null,
        citiesStart: null,
        citiesEnd: null,
      },
      params: {
        page: 1,
      },
      selects: [],
      statistics: {},
      countOrders: "",
      pincode: "",
      messageError: [],
      localLoading: true,
      dataTable: [],
      activeSelectRowsMultiple: [],
      filter: [],
      computedAllPage: 1,
      currentPage: 1,
      activePagePagination: {
        total: 0,
        count: 0,
        limit: 0,
        page: 0,
      },
      rowStyleOption: {
        stripe: true,
      },
      cellSelectionOption: {
        enable: false,
      },
      cellStyleOption: {
        bodyCellClass: ({ row, column, rowIndex }) => {
          return row.order_statuses__style_class;
        },
      },
      limitPaginationValue: 50,
    };
  },

  methods: {
    setSelect(e, fieldName, fieldValue) {
      if (!e) {
        const idx = this.filter.findIndex((x) => x.field == fieldName);
        if (idx >= 0) {
          this.filter.splice(idx, 1);
        }
        return;
      }
      if (!this.filter.find((x) => x.field == fieldName)) {
        this.filter.push({
          field: fieldName,
          value: e[fieldValue],
        });
      } else {
        this.filter[this.filter.findIndex((x) => x.field == fieldName)].value =
          e[fieldValue];
      }
    },
    updateLimitValue(data) {
      this.limitPaginationValue = data;
      this.loadData();
    },
    sendData(callback, nameTab, oldTab, newTab, flagIsClose) {
      EventBus.$emit("contentLoaded");
      EventBus.$emit("updateContentData");
      callback(true, nameTab, oldTab, newTab, flagIsClose);
    },
    async loadExel() {
      let dataFrom = await GeneralService.toExcel(this.currentOpenedId, {
        where: JSON.stringify(this.filter),
      });

      const filename = new Date().toISOString();
      const url = window.URL.createObjectURL(dataFrom.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${filename}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
    },
    selectedRowChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    acceptDelete() {
      if (this.activeSelectRowsMultiple.length) {
        GeneralService.delete("/orders/" + this.activeSelectRowsMultiple, {
          ...(this.pincode && { pincode: this.pincode }),
        })
          .then((data) => {
            // this.selects.push(data.data.data.rows)

            this.loadData(1);
            this.$toast.success(data.data.message);
            this.$modal.hide("acceptDeleteWithPin");
          })
          .catch((e) => {
            if (e.response.status == 409) {
              this.$modal.show("acceptDeleteWithPin");
              // this.$toast.error(e.response.data.message, {
              //   duration: 5000,
              // });
            } else if (e.response.status == 400) {
              this.$toast.error(e.response.data.message, {
                duration: 5000,
              });
            }
          });
      } else {
        this.$toast.error("Выберите хотя-бы одно поле", { duration: 5000 });
      }
    },
    fromArchive() {
      if (this.activeSelectRowsMultiple.length) {
        GeneralService.get(
          "/orders/from/archive/" + this.activeSelectRowsMultiple,
          {}
        )
          .then((data) => {
            // this.selects.push(data.data.data.rows)

            this.loadData(1);
            this.$toast.success(data.data.message);
          })
          .catch((e) => {
            // if (e.response.status == 409) {
            //   this.$modal.show('acceptDeleteWithPin')
            // }
          });
      } else {
        this.$toast.error("Выберите хотя-бы одно поле", { duration: 5000 });
      }
    },
    // urlToQuaries: {
    //   deep: true,
    //   get() {
    //     return {
    //       url: `/orders/table/archive`,
    //       params: {
    //         limit: this.limitPaginationValue,
    //         page: this.params.page,
    //         ...(this.filter.length && { where: JSON.stringify(this.filter) })
    //       }
    //     }
    //   },
    //   set(newNumPage) {
    //     this.params.page = newNumPage
    //   }
    // },
    // urlToQuaries(newNumPage) {
    //   return {
    //     url: `/orders/table/archive`,
    //     params: {
    //       limit: this.limitPaginationValue,
    //       page: newNumPage ? newNumPage : 1,
    //       ...(this.filter.length && { where: JSON.stringify(this.filter) })
    //     }
    //   }
    // },
    loadData(numPage) {
      this.localLoading = true;
      // this.urlToQuaries.params.page = newNumPage;
      Promise.all([
        GeneralService.get("/orders/table/archive", {
          params: {
            limit: this.limitPaginationValue,
            page: numPage,
            ...(this.filter.length && { where: JSON.stringify(this.filter) }),
          },
        }).then((data) => {
          this.countOrders = data.data.data.count;

          this.computedAllPage = Math.ceil(
            data.data.data.total / data.data.data.limit
          );
          //
          this.dataTable = data.data.data.rows;
          this.statistics = data.data.data.statistics_by_order;
          this.activeSelectRowsMultiple = [];
          //
          this.activePagePagination = data.data.data;
          //
        }),
      ]).then(() => {
        this.localLoading = false;
      });
    },
    resetFilter() {
      // this.selectsData
      this.filter = [];
      this.loadData(1);

      this.selectsFilter = {
        type: [],
        statuses: [],
      };
      this.dataTimeSelect = {
        orders_from: "",
        orders_to: "",
      };
      this.$refs.mainTable.$el
        .querySelectorAll("input.base-input--new")
        .forEach((elem, index) => {
          elem.value = "";
        });
      this.counter++;
    },
    fillFilter(data) {
      let newValueFilter =
        data.type == "like" ? `;percent;${data.value};percent;` : data.value;
      if (!this.filter.find((x) => x.field == data.name)) {
        this.filter.push({
          field: data.name,
          value: newValueFilter,
          ...(data.type == "like" && { operator: "like" }),
        });
      } else {
        this.filter[this.filter.findIndex((x) => x.field == data.name)].value =
          newValueFilter;
      }
    },
    pincodeModalHandler() {
      this.pincode = "";
      this.activeSelectRowsMultiple = [];
      this.messageError = "";
    },
    fillDateFilter(data) {
      // [{"field":"orders__created_at", "value":["2024-01-04", "2024-01-15"], "operator":"between", "mod":"date"}]
      let transformData = data.value
        ? data.value.split(".").reverse().join("-")
        : "";
      let time = data.index == 0 ? "00:00" : "23:59";
      console.log(data);
      if (!this.filter.find((x) => x.field == data.name)) {
        let indexedArray = [];
        indexedArray[data.index] = transformData + " " + time;

        this.filter.push({
          field: data.name,
          value: indexedArray,
          operator: "between",
          mod: "date",
        });
      } else {
        this.filter[this.filter.findIndex((x) => x.field == data.name)].value[
          data.index
        ] = transformData + " " + time;
        console.log(this.filter);
      }
    },
    prepareLabelsForDefaultSelects(data, keyDataFromFetch, toTranslate) {
      for (const key in data) {
        data[key].forEach((element) => {
          element["label"] = element[Object.keys(element).pop()];
          element["key"] = key;
          element["value"] = Object.keys(element)[0];
          element["selectName"] = keyDataFromFetch;
        });
      }
      return data;
    },
    ...mapActions("transportVehiclesModule", ["getHealth", "getTitle"]),
  },
  created() {
    Promise.all([
      SelectsService.getAll().then((data) => {
        this.selectsData.types = this.prepareLabelsForDefaultSelects(
          data.data.data.rows,
          "allSelects",
          true
        );
      }),
      GeneralService.get(`/ads`).then((data) => {
        this.selectsData.ads = data.data.data.rows;
      }),
      GeneralService.get(`/objects/types`).then((data) => {
        this.selectsData.objectTypes = data.data.data.rows;
      }),
      GeneralService.get(`/selects/body-generation`).then((data) => {
        this.selectsData.bodyGenerations = data.data.data.rows;
      }),
      GeneralService.get(
        `/cities?where=[{"field":"cities__country_id","value":1}]`
      ).then((data) => {
        this.selectsData.cities = data.data.data.rows;
      }),

      // нужен ли здесь этот запрос? темболее что локально он отрабатывает с ошибкой
      // GeneralService.get("orders/statuses").then((data) => {
      //   this.selectsData.statuses = data.data.data.rows;
      // }),
    ]).then(() => {
      this.loadData(1);
    });
  },
  computed: {
    ...mapState("translationModule", ["dataLang"]),
    ...mapState("userSettingModule", ["userSetting"]),
    // urlToQuaries() {
    //   console.log(this.filter);

    //   return {
    //     url: `/orders/table/archive`,
    //     params: {
    //       limit: this.limitPaginationValue,
    //       page: this.currentPage,
    //     },
    //   };
    // },
    objectsTypesFiltered() {
      let availableType = ["car", "water", "air"];
      let sortedVehicles = availableType.reduce((result, typeCode) => {
        let found = this.selectsData.objectTypes.find(
          (i) => i.vehicle_types__code === typeCode
        );
        if (found) {
          result.push(found);
        }
        return result;
      }, []);
      return sortedVehicles;
    },
    columns() {
      return [
        {
          title: this.dataLang["orders-page__table__header_order_text1"],
          children: [
            {
              field: "",
              key: "a",

              type: "checkbox",
              title: "",
              width: 5,
              align: "center",
            },
            {
              field: "orders__id",
              key: "12",
              title: this.dataLang["orders-page__table__header_order_text2"],
              align: "left",
              width: "3%",
              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              // renderHeaderCell: ({ column }, h) => {
              //   return (
              //     <div>
              //       <div class={"text-center"}>{column.title}</div>

              //       <BaseInputNew
              //         placeholder=""
              //         style={"width: 100%"}
              //         disabled={false}
              //         onInput={this.fillFilter}
              //         additionalParams={{ type: "input" }}
              //         inputName={"orders__id"}
              //         value={""}
              //         nameSign={""}
              //       />
              //     </div>
              //   );
              // },
            },

            {
              field: "orders__created_at",
              key: "13",
              title: this.dataLang["orders-page__table__header_order_text3"],
              align: "left",
              width: "8%",

              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },

              renderBodyCell: ({ row, column, rowIndex }, h) => {
                return (
                  <span>
                    {row.orders__created_at
                      ? this.$time(row.orders__created_at)
                          .utc(true)
                          .utcOffset(Number(this.userSetting.company__utc))
                          .format(
                            `${this.userSetting.company__tempalte_date} HH:mm`
                          )
                      : ""}
                  </span>
                );
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div class={"text-center"}>{column.title}</div>

                    <div style={"height: 19.5px"}></div>
                  </div>
                );
              },
            },
            {
              field: "ads__name",
              key: "14",
              title: this.dataLang["orders-page__table__header_order_text4"],
              align: "left",
              width: 70,

              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              /* renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div class={"text-center"}>{column.title}</div>

                    <BaseInputNew
                      placeholder=""
                      style={"width: 100%"}
                      disabled={false}
                      onInput={this.fillFilter}
                      additionalParams={{ type: "input" }}
                      inputName={"ads__name"}
                      value={""}
                      nameSign={""}
                    />
                  </div>
                );
              }, */
            },
            {
              field: "orders__type_rent",
              key: "15",
              title: this.dataLang["orders-page__table__header_order_text5"],
              align: "left",
              width: 70,

              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              /* renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <span>{column.title}</span>
                    <BaseSelect
                      vModel={this.selectsFilter.type}
                      onInput={(e, w) => {
                        if (
                          !this.filter.find(
                            (x) => x.field == "orders__type_rent"
                          )
                        ) {
                          this.filter.push({
                            field: "orders__type_rent",
                            value: e.value,
                          });
                        } else {
                          this.filter[
                            this.filter.findIndex(
                              (x) => x.field == "orders__type_rent"
                            )
                          ].value = e.value;
                        }
                      }}
                      style={"width: 100%"}
                      label={"label"}
                      placeholder={""}
                      id={"cities__id"}
                      selectLabel={""}
                      deselectLabel={""}
                      options={this.selectsData.types.orders__type_rent}
                    ></BaseSelect>
                  </div>
                );
              }, */
              renderBodyCell: ({ row, column, rowIndex }, h) => {
                return <span>{this.dataLang[row.orders__type_rent]}</span>;
              },
            },
            {
              field: "orders__vehicle_type",
              key: "16",
              title: this.dataLang["orders-page__table__header_order_text6"],
              align: "left",
              width: "8%",

              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              renderBodyCell: ({ row, column, rowIndex }, h) => {
                return <span>{this.dataLang[row.orders__vehicle_type]}</span>;
              },
              /* renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div class={"text-center"}>{column.title}</div>

                    <BaseInputNew
                      placeholder=""
                      style={"width: 100%"}
                      disabled={false}
                      onInput={this.fillFilter}
                      additionalParams={{ type: "input" }}
                      inputName={"orders__vehicle_type"}
                      value={""}
                      nameSign={""}
                    />
                  </div>
                );
              }, */
            },
            {
              field: "orders__body_generation",
              key: "222",
              title: this.dataLang["orders-page__table__header_order_text7"],
              align: "left",
              width: 70,

              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              /* renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div class={"text-center"}>{column.title}</div>

                    <BaseInputNew
                      placeholder=""
                      style={"width: 100%"}
                      disabled={false}
                      onInput={this.fillFilter}
                      additionalParams={{ type: "input" }}
                      inputName={"orders__body_generation"}
                      value={""}
                      nameSign={""}
                    />
                  </div>
                );
              }, */
              renderBodyCell: ({ row, column, rowIndex }, h) => {
                return (
                  <span>{this.dataLang[row.orders__body_generation]}</span>
                );
              },
            },
            {
              field: "orders__start_city_name",
              key: "23",
              title: this.dataLang["orders-page__table__header__order_text8"],
              align: "left",
              width: 90,

              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              /* renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div class={"text-center"}>{column.title}</div>

                    <BaseInputNew
                      placeholder=""
                      style={"width: 100%"}
                      disabled={false}
                      onInput={this.fillFilter}
                      additionalParams={{ type: "input" }}
                      inputName={"orders__start_city_name"}
                      value={""}
                      nameSign={""}
                    />
                  </div>
                );
              }, */
            },
            {
              field: "orders__end_city_name",
              key: "24",
              title: this.dataLang["orders-page__table__header_order_text9"],
              align: "left",
              width: 90,

              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              /* renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div class={"text-center"}>{column.title}</div>

                    <BaseInputNew
                      placeholder=""
                      style={"width: 100%"}
                      disabled={false}
                      onInput={this.fillFilter}
                      additionalParams={{ type: "input" }}
                      inputName={"orders__end_city_name"}
                      value={""}
                      nameSign={""}
                    />
                  </div>
                );
              }, */
            },
            {
              field: "orders__starts",
              key: "25",
              title: this.dataLang["orders-page__table__header_order_text10"],
              align: "left",
              width: 70,

              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              renderBodyCell: ({ row, column, rowIndex }, h) => {
                return (
                  <span>
                    {row.orders__starts
                      ? this.$time(row.orders__starts)
                          .utc(true)
                          .utcOffset(Number(this.userSetting.company__utc))
                          .format(
                            `${this.userSetting.company__tempalte_date} HH:mm`
                          )
                      : ""}
                  </span>
                );
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div class={"text-center"}>{column.title}</div>

                    <div style={"height: 19.5px"}></div>
                  </div>
                );
              },
            },
            {
              field: "orders__ends",
              key: "33",
              title: this.dataLang["orders-page__table__header_order_text11"],
              align: "left",
              width: 90,

              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              renderBodyCell: ({ row, column, rowIndex }, h) => {
                return (
                  <span>
                    {row.orders__ends
                      ? this.$time(row.orders__ends)
                          .utc(true)
                          .utcOffset(Number(this.userSetting.company__utc))
                          .format(
                            `${this.userSetting.company__tempalte_date} HH:mm`
                          )
                      : ""}
                  </span>
                );
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div class={"text-center"}>{column.title}</div>

                    <div style={"height: 19.5px"}></div>
                  </div>
                );
              },
            },
            {
              field: "vehicles__fullname",
              key: "34",
              title: this.dataLang["orders-page__table__header_order_text12"],
              align: "left",
              width: 70,

              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              /* renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div class={"text-center"}>{column.title}</div>

                    <BaseInputNew
                      placeholder=""
                      style={"width: 100%"}
                      disabled={false}
                      onInput={this.fillFilter}
                      additionalParams={{ type: "input" }}
                      inputName={"vehicles__fullname"}
                      value={""}
                      nameSign={""}
                    />
                  </div>
                );
              }, */
            },
            {
              field: "orders__duration",
              key: "35",
              title: this.dataLang["orders-page__table__header_order_text13"],
              align: "left",
              width: 70,

              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div class={"text-center"}>{column.title}</div>

                    <div style={"height: 19.5px"}></div>
                  </div>
                );
              },
            },
            {
              field: "orders__cost",
              key: "36",
              title: this.dataLang["orders-page__table__header_order_text14"],
              align: "left",
              width: 70,

              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div class={"text-center"}>{column.title}</div>

                    <div style={"height: 19.5px"}></div>
                  </div>
                );
              },
            },
          ],
        },
        {
          title: this.dataLang["orders-page__table__header_client_text1"],
          children: [
            {
              field: "clients__phone",
              key: "37",
              title: this.dataLang["orders-page__table__header_client_text2"],
              align: "left",
              width: 70,

              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              /* renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div class={"text-center"}>{column.title}</div>

                    <BaseInputNew
                      placeholder=""
                      style={"width: 100%"}
                      disabled={false}
                      onInput={this.fillFilter}
                      additionalParams={{ type: "input" }}
                      inputName={"clients__phone"}
                      value={""}
                      nameSign={""}
                    />
                  </div>
                );
              }, */
            },
            {
              field: "clients__fullname",
              key: "121",
              title: this.dataLang["orders-page__table__header_client_text3"],
              align: "center",
              width: 70,

              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              /* renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div class={"text-center"}>{column.title}</div>

                    <BaseInputNew
                      placeholder=""
                      style={"width: 100%"}
                      disabled={false}
                      onInput={this.fillFilter}
                      additionalParams={{ type: "input" }}
                      inputName={"clients__fullname"}
                      value={""}
                      nameSign={""}
                    />
                  </div>
                );
              }, */
            },
          ],
        },

        {
          title: this.dataLang["orders-page__table__header_timer_text1"],
          children: [
            {
              field: "order_ext__employee_id",
              key: "123",
              title: this.dataLang["orders-page__table__header_timer_text2"],
              align: "left",
              width: 70,

              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div class={"text-center"}>{column.title}</div>

                    <div style={"height: 19.5px"}></div>
                  </div>
                );
              },
            },
            {
              field: "order_statuses__status",
              key: "122",
              title: this.dataLang["orders-page__table__header_timer_text3"],
              align: "left",
              width: 70,

              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              renderBodyCell: ({ row, column, rowIndex }, h) => {
                return <span>{this.dataLang[row.order_statuses__status]}</span>;
              },
              /* renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <span class={"text-center"}>{column.title}</span>
                    <BaseSelect
                      vModel={this.selectsFilter.statuses}
                      onInput={(e, w) => {
                        if (
                          !this.filter.find(
                            (x) => x.field == "orders__status_id"
                          )
                        ) {
                          this.filter.push({
                            field: "orders__status_id",
                            value: e.order_statuses__id,
                          });
                        } else {
                          this.filter[
                            this.filter.findIndex(
                              (x) => x.field == "orders__status_id"
                            )
                          ].value = e.order_statuses__id;
                        }
                      }}
                      style={"width: 100%"}
                      placeholder={""}
                      customLabel={({ order_statuses__status }) => {
                        return this.dataLang[order_statuses__status];
                      }}
                      id={"order_statuses__id"}
                      selectLabel={""}
                      deselectLabel={""}
                      options={this.selectsData?.statuses}
                    ></BaseSelect>
                  </div>
                );
              }, */
            },
          ],
        },
        {
          title: this.dataLang["orders-page__table__header_e_text1"],
          children: [
            {
              field: "order_ext__employee_id",
              key: "124",
              title: this.dataLang["orders-page__table__header_order_text2"],
              align: "left",
              width: 70,

              ellipsis: {
                showTitle: true,
                lineClamp: 1,
              },
              /* renderHeaderCell: ({ column }, h) => {
                return (
                  <div>
                    <div class={"text-center"}>{column.title}</div>

                    <BaseInputNew
                      placeholder=""
                      style={"width: 100%"}
                      disabled={false}
                      onInput={this.fillFilter}
                      additionalParams={{ type: "input" }}
                      inputName={"order_ext__employee_id"}
                      value={""}
                      nameSign={""}
                    />
                  </div>
                );
              }, */
            },
          ],
        },
      ];
    },
  },
};
</script>
